"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../");
const ModalContainer_1 = require("./ModalContainer");
const ButtonsContainer = styled_components_1.default.ul `
	display: flex;
	justify-content: center;
	list-style-type: none;
`;
const Modal = (_a) => {
    var { root, callback } = _a, _b = _a.translatedKeys, { title, description, yesButtonLabel, noButtonLabel } = _b, rest = __rest(_b, ["title", "description", "yesButtonLabel", "noButtonLabel"]), { customStyle } = _a;
    return (react_1.default.createElement(ModalContainer_1.ModalContainer, { ariaLabelledBy: description ? 'modal-title modal-desc' : 'modal-title', mainContainerIdToHide: root ? 'root' : 'storeroot', translatedKeys: rest },
        react_1.default.createElement(__1.Title, { id: 'modal-title', title: title, customStyle: customStyle }),
        !!description && react_1.default.createElement("p", { id: 'modal-desc', style: { textAlign: 'center' } },
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: description.replace(/\n/g, '<br />') } })),
        react_1.default.createElement(ButtonsContainer, null,
            react_1.default.createElement("li", null,
                react_1.default.createElement(__1.Button, { type: 'button', label: noButtonLabel, onClick: () => callback(false), buttonTheme: 'light', dataTestId: 'modal-button-no' })),
            react_1.default.createElement("li", null, yesButtonLabel && (react_1.default.createElement(__1.Button, { type: 'button', label: yesButtonLabel, onClick: () => callback(true), dataTestId: 'modal-button-yes', customStyle: customStyle }))))));
};
exports.Modal = Modal;
